import { AD_SERVERS, STATE_SERVICE } from '../../../configs/constants';
import { setAdServicesState } from '../ad-services.utils';
import { loadADOCEANScript } from '../../../helpers/load-ado-script';
import {
    embeddingSlots,
    // getNotLazyLoadingSlotsOnSite,
    prepareInitialADOCEANServiceConfig,
    setADOConfig,
    // setADOMaster,
    setOnEmit,
    setOnMaster,
} from './embedding-adocean.utils';
import DebugUANC from '../../../core/version/debug';

export default async (): Promise<void> => {
    const { UANC, exSettings } = window.Inpl.Ad;
    UANC!.unresolvedServices.push(AD_SERVERS.ADOCEAN);

    try {
        await loadADOCEANScript();
    } catch (e) {
        UANC instanceof DebugUANC && UANC.error(`[ADOCEANScript] Problem with ADOCEAN script - ${e}`);
        UANC?.setState({ isAdoScriptReady: false });
        setAdServicesState(AD_SERVERS.ADOCEAN, STATE_SERVICE.REJECTED);
        return;
    }

    // przygotowanie defaultowej/startowej konfiguracji ADOCEANService
    window.Inpl.Ad.services = {
        ...window.Inpl.Ad.services,
        resolved: false,
        ADOCEANService: prepareInitialADOCEANServiceConfig(),
    };

    window.adocf = {
        useDOMContentLoaded: true,
    };

    // w przypadku braku slotów kończymy działanie embedding ADOCEAN
    if (!window.Inpl.Ad.services.ADOCEANService?.slots.length) {
        UANC!.unresolvedServices = UANC!.unresolvedServices.filter((service) => service !== AD_SERVERS.ADOCEAN);
        console.info('ADOCEANService finished - no slots to embedding.');
        return;
    }

    setADOConfig();
    setOnMaster();

    if (!exSettings?.designSystem) {
        setOnEmit(() => setAdServicesState(AD_SERVERS.ADOCEAN, STATE_SERVICE.READY));
        embeddingSlots();
    } else {
        setOnEmit();
        setAdServicesState(AD_SERVERS.ADOCEAN, STATE_SERVICE.READY);
    }
    // setADOMaster(getNotLazyLoadingSlotsOnSite(window.Inpl.Ad.services.ADOCEANService!.slots));
};
